'use strict';
import React, { PureComponent } from 'react';
import CuentasContablesRegistrosBuscador from './CuentasContablesRegistrosBuscador';


class BuscadorCuentasContables extends PureComponent {
    constructor(props) {
        super(props);

        this.limpiarBusqueda = this.limpiarBusqueda.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.buscarCuentasContables = this.buscarCuentasContables.bind(this);
        this.cambiarInputActivo = this.cambiarInputActivo.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    cambiarInputActivo() {
        this.props.cambiarInputActivo(this.props.seccionInput, this.props.nombreInput);
    }

    buscarCuentasContables(event) {
        let valorInput = event.target.value;

        this.props.buscarCuentasContables(this.props.seccionInput, this.props.nombreInput, valorInput);
    }

    limpiarBusqueda() {
        this.props.buscarCuentasContables(this.props.seccionInput, this.props.nombreInput, "");
        this.props.cambiarInputActivo(this.props.seccionInput, "");
    }

    onKeyPress(event) {
        let regExp = /[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ \s]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    onKeyDown(event) {
        event.preventDefault();
        return false;
    }

    render() {
        const {
            contenedorInputBuscador,
            cuentasContables,
            estaHabilitado,
            estiloPlaceholder,
            inputActivo,
            inputClassValorSeleccionado,
            nombreInput,
            positionRelative,
            seccionInput,
            valorInput            
        } = this.props;

        //ACTIONS
        const {
            cambiarInputActivo,
            guardarValorInput
        } = this.props;

        let arrayCuentas = [];

        cuentasContables && cuentasContables.map(cuenta => {
            arrayCuentas.push(<CuentasContablesRegistrosBuscador
                                    cambiarInputActivo={cambiarInputActivo}
                                    cuenta={cuenta}
                                    guardarValorInput={guardarValorInput}
                                    key={nombreInput + cuenta.Codigo}
                                    nombreInput={nombreInput}
                                    seccionInput={seccionInput}
                              />);
        });

        arrayCuentas = arrayCuentas.length == 0 ? 
                                <div className="ABMModelos__opcionBuscadorCuentasContablesSinResultados">No se encontraron resultados</div>
                            : 
                                arrayCuentas;


        let claseContenedorInputBuscador = contenedorInputBuscador ? contenedorInputBuscador : "";

        return (
            <div>
                <div className="col-md-12 seccionSuperior__buscador ABMModelosModalContainer__buscadorMargen">
                    {!inputClassValorSeleccionado ?
                        <div className={"AsientosContables--floatLeft seccionSuperior__iconoLupa ABMModelosModalContainer__iconoLupaInput" + (estaHabilitado ? "" : " seccionSuperior__iconoLupaDeshabilitado")}></div>
                    :
                        null
                    }

                    <div className={"AsientosContables--floatLeft " + claseContenedorInputBuscador}>
                        <input
                            className={"textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs seccionSuperior__inputBuscador ABMModelosModalContainer__buscadorAncho" + inputClassValorSeleccionado + (!estaHabilitado ? estiloPlaceholder : "")}
                            disabled={!estaHabilitado}
                            id={nombreInput}
                            name={nombreInput}
                            onChange={this.buscarCuentasContables}
                            onClick={inputClassValorSeleccionado ? null : this.cambiarInputActivo}
                            onFocus={null}
                            onKeyDown={inputClassValorSeleccionado ? this.onKeyDown : null}
                            onKeyPress={this.onKeyPress}
                            placeholder="Buscar por nombre o nro y seleccionar opción"
                            readOnly={inputClassValorSeleccionado}
                            value={valorInput}
                        />
                    </div>


                    {valorInput && valorInput.length > 0 ?
                        <div className="seccionSuperior__botonBuscador ABMModelosModalContainer__buscadorBotonBorrarBusqueda">
                            <button type="button" className="btn-tag seccionSuperior__botonBorrarBusqueda"
                                onClick={this.limpiarBusqueda}>
                                <span className="ti-close span-closable" />
                            </button>
                        </div>
                    :
                        null
                    }
                </div>

                <div className={"modalLogIntentosScroll ABMModelos__ContenedorOpcionesBuscadorCuentasContables slider-tarjetas" + (nombreInput == inputActivo ? "" : " closed") }>
                    {arrayCuentas}
                </div>
            </div>
        );
    }
}

export default BuscadorCuentasContables;